import React from 'react'
import { Breadcrumb, Card, Col, Icon, Layout, message, Row, Tabs } from 'antd'
import { withRouter } from 'react-router-dom'

import SubsidiaryDetails from './SubsidiaryDetails'
import Profile from './Profile'
import Details from './Details'
import Banking from '../../People/Member/Banking'
import DocumentsCont from '../../Common/Documents/DocumentsCont'
import BudgetCont from '../../../components/Common/Budgets/BudgetCont'
import { get } from 'lodash'
import { compose } from 'recompose'
import withLoadingSection from '../../../elements/HOC/withLoadingSection'
import CatalogsCont from '../../../components/Common/Catalogs/CatalogsCont'

const { Content } = Layout
const { TabPane } = Tabs

function Subsidiary(props) {
  const { member, subsidiary, repsList, memberFetching, subsidiaryFetching } = props

  return (
    <Content style={{ margin: '0px 0px' }}>
      <Card>
        <Row>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="#/corporates">Corporate</Breadcrumb.Item>
            <Breadcrumb.Item href="#/corporates/subsidiaries/list">Tenant List</Breadcrumb.Item>
            <Breadcrumb.Item>{member.fn}</Breadcrumb.Item>
          </Breadcrumb>
        </Row>
      </Card>
      <Row gutter={16} style={{ padding: 10 }}>
        <Col span={24}>
          <Row style={{ paddingTop: '10px' }}>
            <Card style={{ minHeight: '542px' }}>
              <Details subsidiary={subsidiary} member={member} loading={memberFetching} />
              <Row style={{ paddingTop: '10px' }}>
                <Tabs
                  defaultActiveKey={get(props, 'location.hash') || '#profile'}
                  onChange={(key) => props.history.push(key)}>
                  <TabPane
                    tab={
                      <span>
                        <Icon type="user" />
                        Profile
                      </span>
                    }
                    key="#profile">
                    <Profile repsList={repsList} member={member} loading={memberFetching} />
                  </TabPane>
                  <TabPane
                    tab={
                      <span>
                        <Icon type="setting" />
                        Corporate Details
                      </span>
                    }
                    key="#subsidiary">
                    <SubsidiaryDetails {...props} loading={subsidiaryFetching} />
                  </TabPane>
                  <TabPane
                    tab={
                      <span>
                        <Icon type="bank" />
                        Banking Details
                      </span>
                    }
                    key="#bank">
                    <Banking member={member} employee={subsidiary} />
                  </TabPane>
                  <TabPane
                    tab={
                      <span>
                        <Icon type="credit-card" />
                        Budget
                      </span>
                    }
                    key="#budgets">
                    <BudgetCont hideOptions={{ existing: true }} loading={memberFetching} owner={subsidiary} />
                  </TabPane>
                  <TabPane
                    tab={
                      <span>
                        <Icon type="windows" /> Products
                      </span>
                    }
                    key="#products">
                    <CatalogsCont member={member} />
                  </TabPane>
                  <TabPane
                    tab={
                      <span>
                        <Icon type="folder-open" />
                        Documents
                      </span>
                    }
                    key="#documents">
                    <DocumentsCont owner={subsidiary} />
                  </TabPane>
                </Tabs>
              </Row>
            </Card>
          </Row>
        </Col>
      </Row>
    </Content>
  )
}

export default compose(withLoadingSection, withRouter)(Subsidiary)
